import { useEffect, useRef, useState } from "react";

export const useScrollToBottom = (threshold: number = 50) => {
  const [hasReachedBottom, setHasReachedBottom] = useState(false);
  const mainRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (mainRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = mainRef.current;

        if (scrollTop + clientHeight >= scrollHeight - threshold) {
          setHasReachedBottom(true);
        }
      }
    };

    const mainElement = mainRef.current;
    if (mainElement) {
      mainElement.addEventListener("scroll", handleScroll);
      // 초기 스크롤 위치 확인
      handleScroll();
    }

    return () => {
      if (mainElement) {
        mainElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, [threshold]);

  const handleScrollDown = () => {
    if (mainRef.current) {
      mainRef.current.scrollTo({
        top: mainRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  return {
    mainRef,
    hasReachedBottom,
    handleScrollDown,
    setHasReachedBottom,
  };
};
